























































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CompanyInfo extends Vue {
  @Prop() private msg!: string;

  companyInfo = {
    image: 'logo.png',
    tag: '#教育科技 #toC #日本用戶20萬以上',
    location: '總公司位於台灣',
    investmentStatus: 'A輪募資完成',
    number: 'TW0001',
    companyName: '下一步，亞洲最大的英語教育科技新創公司',
    description: `介紹內容介紹內容介紹內容介紹內容介紹內容介紹內容介紹
                 介紹內容介紹內容介紹內容介紹內容介紹內容介紹內容介紹
                 介紹內容介紹內容介紹內容介紹內容介紹內容介紹內容介紹`,
    investmentDemand: '戰略性投資、廣告行銷、通路代理商、技術合作',
    established: '2013',
    capitalInvestment: '1億円',
    employees: '60',
    revenue: '4億円',
  };
}
